// src/config/roles.js
// ロールごとの表示用ラベルとカラー。topbar / dashboard / アラート色で共有する。

export const ROLE_LABEL = {
  student:        '学生',
  teacher:        '教師',
  academic_staff: '教務',
  developer:      '開発者'
};

export const ROLE_COLOR = {
  student:        '#22c55e',
  teacher:        '#3b82f6',
  academic_staff: '#f59e0b',
  developer:      '#8b5cf6'
};
